// @ts-nocheck
import { Box, Button, Modal, Typography, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";

import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";

import Star from "../../../../../assets/images/star.svg";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  addSessionToPositionBoardAction,
  removeSessionToPositionBoardAction,
} from "../../../../../store/actions/createEvent";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CustomHelper from "../../../../../components/Helper/CustomHelper";
import { useCallback } from "react";

const SessionSelectorForPositionBoard = ({
  open,
  noDispatch = false,
  handleClose,
  selectedSessionIds,
  onClickGivenSessionHandler,
  showNewModalIcon,
  removeSessionHandler,
  onNewModalClick,
}) => {
  const { sessionsOfEvent: data } = useSelector(
    (state) => state.createContactInfo,
  );

  const dispatch = useDispatch();

  // media query hooks start...
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // media query hooks end...

  const getTotalPositions = (item) => {
    const allPos = [];
    item?.position?.forEach((position) => {
      position?.positionData?.forEach((po) => {
        allPos.push(po?._id);
      });
    });
    return allPos?.length;
  };

  const totalPositions = useCallback((session) => {
    let tot = 0;
    let positionCount = 0;
    session?.position?.forEach((pos) => {
      tot += pos?.positionData?.length ?? 0;
      if (pos?.positionData?.length > 0) {
        positionCount += 1;
      }
    });
    return `${positionCount} ${positionCount > 1 ? "Positions" : "Position"} - ${tot} ${tot > 1 ? "Shifts" : "Shift"} `;
  }, []);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "fit-content",
          height: "fit-content",
          zIndex: 10,
          "@media (max-width: 600px)": {
            height: "fit-content",
            width: "90%",
          },
        }}
      >
        <Box
          sx={{
            flex: "0 0 500px",
            width: "500px",
            margin: "0 auto 10px auto",
            borderRadius: "12px",
            padding: "16px",
            border: "1px solid #D175B6",
            background: "#000",
            boxShadow: "0px 0px 30px 0px rgba(255, 255, 255, 0.20)",
            height: "fit-content",
            "& > div + div": {
              marginTop: "16px",
            },
            "& > div": {
              padding: "16px",
            },
            "@media (max-width: 600px)": {
              width: "100%",
            },
          }}
        >
          {data?.length > 0 ? (
            data?.map((item, index) => {
              return (
                <Box
                  key={index}
                  sx={{
                    padding: "16px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    border: "1px solid #D175B6",
                    display: "flex",
                    flexDirection: isSmallScreen ? "column" : "row",
                    justifyContent: "space-between",
                  }}
                  onClick={() => {}}
                  className={`${selectedSessionIds?.includes(item?._id) ? "active-room" : ""}`}
                >
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontSize: "20px",
                          color: "#ffffff",
                          display: "flex",
                          alignItems: "center",
                          marginRight: "10px",
                          "& img": {
                            marginLeft: "10px",
                          },
                        }}
                      >
                        {item.sessionName}
                        {!isSmallScreen ? <img src={Star} /> : null}
                      </Typography>
                      <Typography
                        sx={{
                          color: `${
                            selectedSessionIds?.includes(item?._id)
                              ? "white"
                              : "#D175B6"
                          }`,
                        }}
                      >
                        {totalPositions(item)}
                      </Typography>
                    </Box>
                    {isSmallScreen ? (
                      <Typography sx={{ fontSize: "12px", marginTop: "5px" }}>
                        {`${dayjs(item.sessionStart).format("DD MMM, YYYY")} - ${dayjs(item.sessionEnd).format("DD MMM,YYYY")}`}
                      </Typography>
                    ) : (
                      <Typography sx={{ fontSize: "12px", marginTop: "5px" }}>
                        {`Start from ${dayjs(item.sessionStart).format("DD MMM, YYYY")} - Ends at ${dayjs(item.sessionEnd).format("DD MMM,YYYY")}`}
                      </Typography>
                    )}
                  </Box>
                  <Box
                    sx={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {showNewModalIcon ? (
                      <CustomHelper
                        message={
                          selectedSessionIds?.includes(item?._id)
                            ? "Remove sesison from grid view"
                            : "Add session to grid view"
                        }
                      >
                        <Button
                          variant="text"
                          sx={{
                            backgroundColor: "white",
                            width: "2rem",
                            height: "2rem",
                            minWidth: "auto",
                            ":hover": {
                              backgroundColor: "white",
                              boxShadow: `0px 30px 80px 0px rgba(255, 0, 255, 0.30), 0px 0px 20px 0px ${getCssVariableHandler({ variableName: "--primary-pink-rgb" })} inset`,
                            },
                          }}
                          onClick={(e) => {
                            e?.stopPropagation();
                            if (selectedSessionIds?.includes(item?._id)) {
                              if (!noDispatch) {
                                dispatch(
                                  removeSessionToPositionBoardAction({
                                    payload: {
                                      sessionId: item?._id,
                                    },
                                  }),
                                );
                              }
                              removeSessionHandler(item);
                            } else {
                              if (!noDispatch) {
                                dispatch(
                                  addSessionToPositionBoardAction({
                                    payload: {
                                      sessionId: item?._id,
                                    },
                                  }),
                                );
                              }
                              onNewModalClick(item);
                            }
                          }}
                        >
                          {/* <OpenInNew /> */}
                          {selectedSessionIds?.includes(item?._id) ? (
                            <RemoveIcon />
                          ) : (
                            <AddIcon />
                          )}
                        </Button>
                      </CustomHelper>
                    ) : null}
                  </Box>
                </Box>
              );
            })
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography>No sessions</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};
SessionSelectorForPositionBoard.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  selectedSessionIds: PropTypes.array,
  noDispatch: PropTypes.bool,
};

export default SessionSelectorForPositionBoard;